export default [
  {
    path: '/inventory-lists',
    name: 'inventory-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/inventory-list/index.vue')
  }
]
